import styled from 'styled-components';

export const SibebarWrapper = styled.div`
  transition: all .001s linear;
  min-height: calc(100vh - 120.75px);
  z-index: 1;
  background-color: #222d32;
  color: #fff;
  @media (min-width: 990px){
    width: ${props => props.open ? "50px" : "262px"};
    left: ${props => props.open ? "0" : "50px"};
  }
  @media (max-width: 990px){
    width: ${props => props.open ? "0" : "262px"};
    left: ${props => props.open ? "0" : "-262px"};
  }

  > div {
    margin-bottom: -10000%;
    padding-bottom: 10000%;
  }

  i {
    padding-right: 5px;
    min-width: 20px;
    @media (max-width: 990px){
      display: ${props => props.open ? "none" : "inline-block"};
    }
  }

  a {
    color: #b8c7ce;
    width: ${props => props.open ? "50px" : "230px"};
    display: flex;
    padding: 15px;
    @media (max-width: 990px){
      display: ${props => props.open ? "none" : "block"};
    }


    &:hover {
      background-color: #1e282c;
      color: #fff;
    }
  }
  span {
    display: none;
    display: ${props => props.open ? "none" : "inline-block"};
  }
`;

export const WrapperForSidebarElements = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

export const HiddenSidebarWrapper = styled.div`
  @media (min-width: 991px){
    display: none;
  }
`;

export const Arrow = styled.span`
  i {
    float: right !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/components.js